import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SidebarMenuComponent } from './sidebar-menu/sidebar-menu.component';
import { AppPlacidComponent } from './app-placid/app-placid.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LoaderComponent } from './shared/loader/loader/loader.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CustomSpinnerDirective } from './shared/loader/custom-loader.dir';
import { TabletModalComponent } from './preview-modal/tablet-modal/tablet-modal.component';
import { DesktopModalComponent } from './preview-modal/desktop-modal/desktop-modal.component';
import { MobileModalComponent } from './preview-modal/mobile-modal/mobile-modal.component';
import { AppVihoComponent } from './app-viho/app-viho.component';
import { EventListVihoComponent } from './shared/event-list/event-list-viho/event-list-viho.component';
import { EventsVihoComponent } from './events/events-home/events-viho/events-viho.component';
import { UserInfoVihoComponent } from './app-viho/user-info-viho/user-info-viho.component';
import { NgxMasonryModule } from 'ngx-masonry';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { AppDarkVihoComponent } from './app-dark-viho/app-dark-viho.component';
import { LaptopModalComponent } from './preview-modal/laptop-modal/laptop-modal.component';

@NgModule({
  declarations: [
    AppComponent,
    SidebarMenuComponent,
    AppPlacidComponent,
    LoaderComponent,
    CustomSpinnerDirective,
    TabletModalComponent,
    DesktopModalComponent,
    MobileModalComponent,
    AppVihoComponent,
    UserInfoVihoComponent,
    AppDarkVihoComponent,
    LaptopModalComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    NgxMasonryModule,
    NgbModalModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ],
  exports: [
    TranslateModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}